module.exports = __webpack_public_path__ + "static/media/jk.127f00a7.png";